export default __webpack_public_path__ + "static/media/telegram.25fe2e28.svg";